import React from 'react'
import { connect } from 'react-redux'
import { Trans } from '@lingui/react'
import IconSubmit from 'react-icons/lib/md/send'
import Button from './Button.js'
import './LastQuestionButtons.css'

const LastQuestionButtons = ({ onReviewClick, onSubmitClick }) => (
  <div className="button-bar">
    <Button ghost onClick={onReviewClick}>
      <Trans>Review answers</Trans>
    </Button>
    <Button primary iconRight onClick={onSubmitClick}>
      <Trans>Submit</Trans>
      <IconSubmit size={24} />
    </Button>
  </div>
)

const mapDispatchToProps = ({
  isMenuOpen: { toggle },
  formState: { submit },
}) => ({
  onReviewClick: () => toggle(),
  onSubmitClick: () => submit(),
})

export default connect(null, mapDispatchToProps)(LastQuestionButtons)



// WEBPACK FOOTER //
// ./src/components/LastQuestionButtons.js